import React from 'react';

interface MoreDotsIconProps {
  size?: number;
}

const MoreDotsIcon: React.FC<MoreDotsIconProps> = ({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <circle cx="12" cy="5" r="2" />
      <circle cx="12" cy="12" r="2" />
      <circle cx="12" cy="19" r="2" />
    </svg>
  );
};

export default MoreDotsIcon;
